import React from 'react';

export type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  stepName: string;
  stepNumber: number;
  currentStep?: number;
  children?: React.ReactNode;
};

export const StepWrapper = (props: Props) => {
  const { children, currentStep, stepNumber } = props;

  const isHidden = currentStep !== stepNumber;
  const styles = isHidden ? { display: 'none' } : {};

  const childrenWithProps = React.Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a typescript error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...props });
    }

    return child;
  });

  return <div style={styles}>{childrenWithProps}</div>;
};
